import './ga4';
import './menu';
import './swiper';
import counterUp from 'counterup2';
import Collapse from 'bootstrap/js/dist/collapse';
import Dropdown from 'bootstrap/js/dist/dropdown';
import Offcanvas from 'bootstrap/js/dist/offcanvas';
import Popover from 'bootstrap/js/dist/popover';
import Tab from 'bootstrap/js/dist/tab';

window.addEventListener("load", function() {
    //
    // détection d'un environnement tactile
    //
    if(!window.matchMedia('(hover: none)').matches) {
        document.body.classList.add('hoverable');
    }

    //
    // initialisation des compteurs
    //
    const callback = entries => {
        entries.forEach(entry => {
            const el = entry.target;

            if(entry.isIntersecting) {
                counterUp(el, {
                    delay: 10,
                    duration: 1000,
                });

                observer.unobserve(el);
            }
        });
    };

    const observer = new IntersectionObserver(callback, {
        threshold: 1,
    });

    document.querySelectorAll('.counter').forEach(counter => {
        observer.observe(counter);
    });

    //
    // initialisation du popover
    //
    const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]');
    const popoverList = [...popoverTriggerList].map(popoverTriggerEl => new Popover(popoverTriggerEl));
});